export default function countLines(string = '') {
  return string.split('\n').length;
}
